import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function PatientSettings() {
  const { profile } = useAuth()
  const navigate = useNavigate()
  const [showDelete, setShowDelete] = useState(false)
  const [deleteConfirm, setDeleteConfirm] = useState('')
  const [deleting, setDeleting] = useState(false)
  const [deleteError, setDeleteError] = useState('')

  async function handleDeleteAccount() {
    if (deleteConfirm !== 'DELETE') return
    setDeleting(true)
    setDeleteError('')
    try {
      const { error } = await supabase.rpc('delete_my_account')
      if (error) { setDeleteError(error.message); setDeleting(false); return }
      await supabase.auth.signOut()
      navigate('/login')
    } catch {
      setDeleteError('Something went wrong. Please try again.')
      setDeleting(false)
    }
  }

  return (
    <>
      <Navbar />
      <div className="page">
        <span onClick={() => navigate('/patient')} className="back-link" style={{ cursor: 'pointer' }}>← Back</span>
        <div className="page-header">
          <h1>Account</h1>
          <p>{profile?.full_name}</p>
        </div>

        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: 15, marginBottom: '0.5rem' }}>Your details</h2>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
            <p style={{ margin: 0, fontSize: 14, color: 'var(--text-secondary)' }}>Name</p>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 500, color: 'var(--text-primary)' }}>{profile?.full_name}</p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
            <p style={{ margin: 0, fontSize: 14, color: 'var(--text-secondary)' }}>Clinic</p>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 500, color: 'var(--text-primary)' }}>{profile?.clinics?.name}</p>
          </div>
        </div>

        <div className="card" style={{ borderColor: '#fecaca' }}>
          <h2 style={{ fontSize: 15, marginBottom: '0.5rem', color: '#dc2626' }}>Delete account</h2>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: '1rem' }}>
            Permanently delete your account and all associated data. This cannot be undone.
          </p>
          <button className="danger" onClick={() => setShowDelete(true)} style={{ fontSize: 13 }}>
            Delete my account
          </button>
        </div>
      </div>

      {showDelete && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
          onClick={e => { if (e.target === e.currentTarget) setShowDelete(false) }}>
          <div style={{ background: 'var(--surface)', borderRadius: '20px 20px 0 0', width: '100%', maxWidth: 640, padding: '1.5rem' }}>
            <h2 style={{ fontSize: 17, marginBottom: 8, color: '#dc2626' }}>Delete account</h2>
            <p style={{ fontSize: 14, marginBottom: '1.5rem', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              This will permanently delete your account and all your data. Type <strong>DELETE</strong> to confirm.
            </p>
            {deleteError && <div className="alert-error" style={{ marginBottom: '1rem' }}>{deleteError}</div>}
            <div className="form-group">
              <input
                placeholder="Type DELETE to confirm"
                value={deleteConfirm}
                onChange={e => setDeleteConfirm(e.target.value)}
                style={{ marginBottom: 12 }}
              />
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  className="danger"
                  onClick={handleDeleteAccount}
                  disabled={deleteConfirm !== 'DELETE' || deleting}
                  style={{ flex: 1, padding: 14 }}
                >
                  {deleting ? 'Deleting...' : 'Delete my account'}
                </button>
                <button className="secondary" onClick={() => { setShowDelete(false); setDeleteConfirm('') }} style={{ flex: 1, padding: 14 }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}